import axios from 'axios';
import { API_BASE_URL, applyInterceptors } from '../api/config'; // This sets up the global axios interceptors

// Create the default axios instance
const api = axios.create({
  baseURL: API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`
});

// Apply auth and fingerprint interceptors specifically to this instance
applyInterceptors(api);

export const getSignedGuideUrl = async (path) => {
  if (!path) return null;
  
  try {
    const response = await api.get(`/core/utils/sign-guide-url/?path=${path}`);
    return response.data.url;
  } catch (err) {
    console.error("Video signing failed", err);
    return null;
  }
};

// AI tutor coupled to a live simulation: { question, sim, state? } -> { answer, actions }.
export const askSimTutor = (payload) =>
  api.post('/core/sim-tutor/', payload, { timeout: 60000 }).then((r) => r.data);

export default api;